import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MessageService } from 'primeng/api';

import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { DistributionService } from '@Common/TargetingShared/services/distribution.service';
import { ToggleAction } from '../../../enums/toggle-action.enum';

@Component({
    selector: 'agpr-lock-search-dialog',
    templateUrl: './lock-search-dialog.component.html',
    styleUrls: ['./lock-search-dialog.component.scss'],
    standalone: false
})
export class LockSearchDialogComponent extends AbstractDialogComponent {

    @Output() updateDistName = new EventEmitter<string>();

    nameExistsError: boolean = false;
    nameRequiredError: boolean = false;

    distName: string = '';
    loading: boolean = false;

    private isValid: boolean = true;

    readonly id = 'lockSearchDialog';
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly toggleAction = ToggleAction;

    constructor(
        coreDialogService: CoreDialogService,
        private distributionService: DistributionService,
        private messageService: MessageService
    ) {
        super(coreDialogService, 'LockSearchDialogComponent');
    }

    confirm() {
        this.isValid = false;
        this.formValidator(this.distName);

        if (this.isValid) {
            this.loading = true;
            this.updateDistName.emit(this.distName.trim());

            this.closeDialog(true);
        } else {
            this.messageService.add({
                severity: messageSeverityEnum.error,
                summary: 'Discover.distribution.saveLockSearchDialog.error.formErrors',
            });
        }
    }


    cancel() {
        this.closeDialog(false);
    }


    private formValidator(name: string) {
        const distributionName = name.trim();

        this.nameExistsError = this.distributionService.distributionExistsWithName(undefined, distributionName);
        this.nameRequiredError = distributionName.length === 0;

        this.isValid = !this.nameExistsError && !this.nameRequiredError;
    }
}
